<template>
  <div class="sidebar-wrapper">
    <el-menu :default-active="defaultActivePath" class="el-menu-vertical">
      <SidebarItem
        v-for="route of routes"
        :key="route.name"
        :item="route"
        :base-path="route.path"
      ></SidebarItem>
      <anchor-nav></anchor-nav>
    </el-menu>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem';
import AnchorNav from './anchor-nav';
import { mapState } from 'vuex';

export default {
  components: {
    SidebarItem,
    AnchorNav,
  },
  mounted() {},
  computed: {
    ...mapState(['routes']),
    defaultActivePath() {
      const { path, meta } = this.$route;
      let newPath = path;

      // 如果需要特殊的高亮，例如在 B 页面时，高亮显示 A 菜单。可以在 meta 中添加 activePath 额外处理
      if (meta.activePath) {
        // 获取根路径
        const currentRootPath = '/' + path.slice(1).split('/').shift();
        // 拼接 activePath
        newPath = [currentRootPath, meta.activePath].join('/');
      }
      return newPath;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-vertical {
  border-right: none;
  position: relative;
}
.el-menu {
  border-radius: 8px;
}
::v-deep .el-menu--inline {
  border-radius: 8px;
}
.sidebar-wrapper {
  width: 200px;
  overflow: hidden;
}
</style>
